import { UserGoal } from 'root-constants'

export const EMAIL_TITLE_MAP = {
  [UserGoal.RELIEVE_STRESS_AND_ANXIETY]: 'onboarding.emailV2.relieveStress',
  [UserGoal.BOOST_MOOD]: 'onboarding.emailV2.boostMood',
  [UserGoal.GET_RID_OF_BRAIN_FOG]: 'onboarding.emailV2.brainFog',
  [UserGoal.ALL_THAT_WAS_MENTIONED]: 'onboarding.emailV2.relieveStress',
}
